import { AfterViewInit, Component, Input, OnInit, inject, DestroyRef, ChangeDetectorRef, ViewChild, ElementRef, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { LwActionsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-action-executor';
import { CommonService } from 'src/app/shared/services/lw-ui-rule/common.service';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CustomFieldRenderer } from 'src/app/shared/services/lw-ui-rule/ltms-custom-field-renderer-v2';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { LtmsDataSource } from 'src/app/shared/services/lw-ui-rule/ltms-data-source';
import { LwComponentRenderer } from 'src/app/shared/services/lw-elements-renderer/lw-component-renderer';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { FileUploadService } from 'src/app/shared/services/file-upload/file-upload.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { timeout } from 'rxjs';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';
import { DomSanitizer  } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
@Component({
    selector: 'app-response-controller',
    templateUrl: './response-controller.component.html',
    styleUrls: ['./response-controller.component.scss'],
    imports: [NgIf, NgFor, FormsModule, LtmsLoaderComponent, DatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResponseControllerComponent implements OnInit, AfterViewInit {
  @ViewChild('statusdd') statusdd!: ElementRef;
  @ViewChild('categorydd') categorydd!: ElementRef;
  @ViewChild('categorydd') subcategorydd!: ElementRef;
  @ViewChild('taglistdd') taglistdd!: ElementRef;
  @Input() feedData: any = {};
  @Input() brandDetails: any = {};
  @Input() feedId: string = "";
  isLoaded: boolean = false;
  @Output() loadingChange = new EventEmitter<any>();
  destroyRef = inject(DestroyRef)
  statusList: any = [];
  selectedStatus: any = {
    name: "Please Select Status"
  };
  tempStatus: any = null;
  hierarchyList: any = [];
  selectedHierarchy: any = {}
  feedDetails: any = {};
  dropdowns: any = {
    status: false,
    hierarchy: false,
    assignee: false,
    category: false,
    sub_category: false,
    parent_child: false
  }

  managerSearch: any = {
    selectedOption: {},
    placeholder: "Please search and select",
    searchfield: "email_address",
    options: [],
    isDisabled: true,
    api: {
      url: this._feedService.getManagerSearchUri(),
      method: "Get",
      parser: this.managerSearchDataProcessor,
    }
  }
  followerSearch: any = {
    selectedOption: {},
    placeholder: "Please search and select",
    searchfield: "email_address",
    options: [],
    isDisabled: true,
    api: {
      url: this._feedService.getManagerSearchUri(),
      method: "Get",
      parser: this.managerSearchDataProcessor,
    }
  }

  assigneeList: any = [];
  categoryList: any = [];
  selectedCategoryUUIDList: any = [];
  selectedCategories: any = {
    selectedCategoryId: '',
    selectedSubCategoryId: '',
    "category": {},
    "sub_category": {}
  };
  isCategoryEnabled: boolean = false;
  isSubCatoryEnabled: boolean = false;
  selectedAssignee: any = {};
  tagList: any = [];
  notes: any = [{
    created_date: "2024-09-16T08:22:21.563Z",
    name: "Pankaj Rajwade",
    text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Ut purus elit, vestibulum ut, placerat ac, adipiscing vitae, felis. Curabitur dictum gravida mauris. Nam arcu libero, nonummy eget, consectetuer id, vulputate a, magna. Donec vehicula augue eu neque."
  }];
  followers: any = []
  attachments: any = [];
  files: any = [];
  isRoleBased: boolean = false;
  hiearchyDropDown: any = {
    options: []
  }
  categoryDropDown: any = {
    options: []
  }
  subCategoryDropDown: any = {
    options: []
  }

  customParameterGroup: any = []
  totalGroupsProcessed: number = 0;
  fieldDefinationHash: any = {};
  fieldDefinitions: any = [];
  roleBasedAssigneeList: any = [];
  roleBasedFollowerList: any = [];
  brandTimezoneDetail = {
    name: "Asia/kolkata",
    offset: '-330'
  }
  rightPaneloaded: boolean = false;

  assigningIssue: boolean = true;
  assigningRoleIssue: boolean = true;
 
  assigneeHash: any = {}
  accordionsMap: any = {}
  loggedInMangerAccessDetails: any = {}
  loggedInManger: any = {};
  roleBasedObject: any = {};
  hierarchyHash: any = null
  accordian: any = {
    assignee: false,
    follower: false,
  }
  statusHash: any = {};
  tagHashForBrandTempTag: any = {};
  tags: any = [];
  categoryListMap: any = {};
  loginResponse: any = null;
  dynamicAccordions: any = [];
  issueTagText: string = "";
  oldStatus: any = null;
  accordionVisibilityFinalConfig: any = {};
  showTags: boolean = false;
  accordionsList: any = [];
  accordionsListHash: any = {};
  is_action_workflow_enabled: boolean = false;
  issueRCAText: string = '';
  actionSelected: string = '';
  noteText: string = '';
  isRCAButtonEnabled: boolean = false;
  serviceToPass: any = {}
  brandDetail: any = {}
  isAssigneeButtonEnabled: boolean = false;
  isFollowerButtonEnabled: boolean = false;
  followerSelectedLevel: any = {}
  assigneeSelectedLevel: any = {}

  roleBasedMangerDetails: any = {}
  constructor(
    private _feedService: FeedsService,
    private commonService: CommonService,
    private LwActionsExecutor: LwActionsExecutor,
    private _ltmsEvent: LtmsEventHandlerService,
    private _helpers: HelpersService,
    private LtmsDataSource: LtmsDataSource,
    private lwComponentRenderer: LwComponentRenderer,
    private _utils: UtilsService,
    private _uploadService: FileUploadService,
    private cdr: ChangeDetectorRef,
    private _domSanitizer: DomSanitizer
  ) {
    this.serviceToPass = {
      _helpers: this._helpers,
      LtmsDataSource: this.LtmsDataSource,
      lwComponentRenderer: this.lwComponentRenderer,
      _utils: this._utils,
      _uploadService: this._uploadService,
      _feedService: this._feedService,
      LwActionsExecutor: this.LwActionsExecutor,
      _ltmsEvent: this._ltmsEvent,
      _domSanitizer: this._domSanitizer,
      SecurityContext: SecurityContext
    }
  }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const mangerListEl: any = document.getElementById(this.scrollConfig.targetId);
      if (this.scrollConfig.targetId != '' && mangerListEl && mangerListEl !== event.target && !mangerListEl?.contains(event.target)) {
        this.closeMangerModal();
      }
      if (this.dropdowns.status && this.statusdd && this.statusdd.nativeElement !== event.target && !this.statusdd.nativeElement.contains(event.target)) {
        this.dropdowns.status = false;
      }
      if (this.dropdowns.category && this.categorydd && this.categorydd.nativeElement !== event.target && !this.categorydd.nativeElement.contains(event.target)) {
        this.dropdowns.category = false;
      }

      if (this.dropdowns.sub_category && this.subcategorydd && this.subcategorydd.nativeElement !== event.target && !this.subcategorydd.nativeElement.contains(event.target)) {
        this.dropdowns.sub_category = false;
      }

      if (this.isTaglistEnabled && this.taglistdd && this.taglistdd.nativeElement !== event.target && !this.taglistdd.nativeElement.contains(event.target)) {
        this.isTaglistEnabled = false;
        this.tagList = [];
      }
    });
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }
  ngOnChanges() {
    this.isLoaded = false;
    this.resetData();
    if (this.feedId) {
      this.rightPaneloaded = false;
      this.brandDetail = Helpers.deepClone(this.brandDetails)
      this.feedDetails = Helpers.deepClone(_.get(this.feedData, 'feed', {}))
      this.feedDetails.tags = Helpers.deepClone(_.get(this.feedData, 'tags', []))
      this.tags = (_.get(this, "brandDetails.tag_list")) ? this.brandDetails["tag_list"] : [];
      this.oldStatus = Helpers.deepClone(_.get(this.feedData.feed, "status_id_list"))
      this.is_action_workflow_enabled = _.get(this.brandDetails, 'is_action_workflow_enabled', false);
      this.prepareAccordianData().then(() => {
        this.prepareFeedDetails(this.feedData)
        this.checkIfRoleBased();
        this.prepareStatusData(this.feedDetails._id);
        if (this.isRoleBased) {
          this.managerSearch.isDisabled = true;
          this.followerSearch.isDisabled = true;
          this.preparehierarchyData(this.brandDetails);
          if (!_.isEmpty(this.feedDetails.role_assigned_to)) {
            this.roleBasedObject[this.feedDetails.role_assigned_to["level"]] = this.feedDetails.role_assigned_to["value"];
            this.roleBasedObject['value'] = this.feedDetails.role_assigned_to["value"];
            this.roleBasedObject['level'] = this.feedDetails.role_assigned_to["level"];
            this.roleBasedObject['text'] = this.hierarchyHash[this.feedDetails.role_assigned_to["level"]];
            this.roleBasedAssigneeList = [this.roleBasedObject];
          }
          if (!_.isEmpty(this.feedDetails.roles_followed_by)) {
            this.feedDetails.roles_followed_by = _.map(this.feedDetails.roles_followed_by, (role: any) => {
              role.levelText = this.hierarchyHash[role["level"]];
              return role;
            })
          }
        } else {
          this.initAssigneeSearch(true, true)
        }
        this.prepareCategoryData();
        // TODO: Enable After proper testing and fixes.
        this.prepareCustomParameter();
      })
     
    }
    this.isLoaded = true
    // this.loadingChange.emit(this.isLoaded)
  }



  resetData() {
    this.statusList = [];
    this.selectedStatus = {
      name: "Please Select Status"
    };
    this.hierarchyList = [];
    this.selectedHierarchy = {}
    this.assigneeList = [];
    this.categoryList = [];
    this.selectedCategoryUUIDList = [];
    this.selectedCategories = {
      "category": {},
      "sub_category": {}
    };
    this.selectedAssignee = {};
    this.tagList = [];
    this.isRoleBased = false;
    this.assigneeHash = {}
  }

  prepareFeedDetails(feedData: any) {
    const managers = _.get(feedData, 'managers', []);
    const statusDetails = _.get(this.brandDetails, 'status_list', [])
    _.each(managers, (manager: any) => {
      this.assigneeHash[manager._id] = manager
    })
    this.loginResponse = _.get(Helpers, 'managerDetails', {});
    this.statusHash = this.createHashMap(statusDetails, 'uuid');
    this.selectedStatus = (_.get(this.feedDetails, 'status_id_list.0')) ? this.statusHash[_.get(this.feedDetails, 'status_id_list.0')] : this.selectedStatus;
    _.each(this.brandDetails.tag_list,)
    this.tags = _.get(this.brandDetails, 'tag_list', []);

    // Create hash for tags 
    this.tagHashForBrandTempTag = this.createHashBasedOnKey(this.tags, "uuid", "name")

  }
  isAssigneeDisabled: boolean = true;
  isFollowerDisabled: boolean = true;
  prepareAccordianData() {
    return new Promise((resolve) => {
      const params: any = {
        issue_id: this.feedId,
        brand_id: this.brandDetails._id,
        'type': 2
      }
      this._feedService.getFieldDefinitions(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        if (response.code == 0 && response.data && !response.data.err) {
          this.accordionsList = response.data.accordions_list;
          this.accordionsListHash = this.createHashBasedOnKey(this.accordionsList, "field_id");
          if (this.accordionsList.length) {
            _.each(this.accordionsList, (accordions) => {
              this.accordionsMap[accordions.field_id] = accordions;
            });
          }
        } else {
          this.accordionsList = [];
          this.accordionsListHash = {};
        }
        this.accordionVisibilityFinalConfig = {};
        var profileVisibilityConfig = this.getAccordionVisibility(null, 'profile');
        this.accordionVisibilityFinalConfig['profile'] = profileVisibilityConfig
        this.accordionVisibilityFinalConfig['transaction'] = this.getAccordionVisibility(null, 'transaction');
        this.accordionVisibilityFinalConfig['notes'] = this.getAccordionVisibility('issueNoteText', 'notes');
        this.accordionVisibilityFinalConfig['status'] = this.getAccordionVisibility('selectFeedStatus', 'status');
        this.accordionVisibilityFinalConfig['assignee'] = this.getAccordionVisibility(null, 'assignee');
        this.accordionVisibilityFinalConfig['follower'] = this.getAccordionVisibility(null, 'follower');
        this.accordionVisibilityFinalConfig['category'] = this.getAccordionVisibility('issueCategory', 'category');
        this.accordionVisibilityFinalConfig['tag'] = this.getAccordionVisibility('issueTagText', 'tag');
        this.isAssigneeDisabled = this.accordionVisibilityFinalConfig['assignee'].read_only;
        this.isFollowerDisabled = this.accordionVisibilityFinalConfig['follower'].read_only;
        resolve(true);
      })
    })
   
  }

  getAccordionVisibility(elemId, searchTypeText) {
    //21684190411LP- enable was not working for accordion
    if (elemId) {
      // $timeout(function() {
      //     $("#" + elemId).prop("disabled", false);
      //     // In the html the close btn(to remove assignee/follower) have the class name prepend with the element Id 
      // }.bind(this), 0);
    }
    if (searchTypeText && this.accordionsListHash && _.get(this.accordionsListHash, searchTypeText)) {
      var accordionConfig = _.get(this.accordionsListHash, searchTypeText);
      var sequenceNo = accordionConfig.sequence_no;


      if (accordionConfig.visible != false && !accordionConfig.read_only) {
        //visible is true read_only false
        return ({ "display_name": accordionConfig.display_name, 'visible': true, 'read_only': false, 'final_value': true, "sequence_no": sequenceNo });
      } else if (accordionConfig.visible != false && accordionConfig.read_only && accordionConfig.read_only == true) {
        //visible is true and read_only true final reasult will be false

        //21684190411LP- issue while evaluating rules so fixed it read-only status accordion wasnt working
        if (elemId) {
          // $timeout(function() {
          //     $("#" + elemId).prop("disabled", true);
          //     if (elemId == "lwIssueAssigneeESFilter") {
          //         $("#lwIssueAssigneeLevelRoleESFilter").prop("disabled", true);
          //     }
          //     // In the html the close btn(to remove assignee/follower) have the class name prepend with the element Id 
          //     $("." + elemId + "-close-btn").hide();
          // }.bind(this), 0);
        }
        return ({ "display_name": accordionConfig.display_name, 'visible': true, 'read_only': true, 'final_value': false, "sequence_no": sequenceNo });
      } else if (accordionConfig.visible == false) {
        return ({ "display_name": accordionConfig.display_name, 'visible': false, 'read_only': false, "sequence_no": sequenceNo });
      } else {
        return ({ "display_name": accordionConfig.display_name, 'visible': true, 'final_value': true, 'read_only': false, "sequence_no": sequenceNo });
      }
    } else {
      return ({ 'visible': true, 'final_value': true, 'read_only': false, "sequence_no": sequenceNo });
    }

  }


  prepareStatusData(feedId: string) {
    if (feedId && feedId != '') {
      const params = {
        brand_id: this.brandDetails._id,
        issue_id: this.feedId
      }
      this._feedService.getStatusList(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        if (response.code == 0 && !_.isEmpty(response.data.status_list)) {
          this.statusList = this.addDefaultPropertiesToStatus(response.data.status_list);
          this.statusList = _.orderBy(this.statusList, ['sequence', 'created_date', 'uuid']);
          let statusMap = this.createHashMap(response.data.status_list, "uuid");
          var issueStatusId: any = _.get(this.feedDetails, "status_id_list.0", null);
          this.selectedStatus = (issueStatusId && statusMap[issueStatusId]) ? statusMap[issueStatusId] : this.selectedStatus;
        }
      });
    }
  }

  addDefaultPropertiesToStatus = function (status_list) {
    let list: any = [];
    if (status_list) {
      var isDeleted = false;
      _.each(status_list, function (data) {
        isDeleted = false;
        switch ((data.name).toLowerCase()) {
          case 'open':
            if (!data.color) {
              data.color = "#c09853";
            }
            if (data.is_enabled != false) {
              data.is_enabled = true;
            }
            break;
          case 'in-progress':
            if (!data.color) {
              data.color = "#5a5a5a";
            }
            if (data.is_enabled != false) {
              data.is_enabled = true;
            }
            break;
          case 'on-hold':
            if (!data.color) {
              data.color = "#b94a48";
            }
            if (data.is_enabled != false) {
              data.is_enabled = true;
            }
            break;
          case 'closed':
            if (!data.color) {
              data.color = "#468847";
            }
            if (data.is_enabled != false) {
              data.is_enabled = true;
            }
            break;

          default:
            break;
        }
        // If is_deleted present in data and its value is true then return true
        isDeleted = ("is_deleted" in data) && data.is_deleted;
        // If is not deleted and status is enabled then push to the list
        if (!isDeleted && data.is_enabled && data.visible != false) {
          list.push(data);
        }
      });
      return list;
    } else {
      return status_list;
    }
  }

  preparehierarchyData(brandDetails: any) {
    let hierarchyName: string = '';
    let hierarchyValues: any = [];
    let hierarchyAlias: any = [];
    this.hierarchyHash = {}
    _.each(brandDetails.hierarchy_list, (value, index) => {
      if (index != 'default' && !hierarchyValues.length) {
        hierarchyName = index;
        hierarchyValues = this.clone(value)
        hierarchyAlias = this.clone(brandDetails.hierarchy_list_alias[index].values)
      }
    })
    _.each(hierarchyValues, (value: any, index: any) => {
      if (value) {
        this.hierarchyHash[hierarchyAlias[index]] = value
        this.hierarchyList.push({
          name: value,
          value: hierarchyAlias[index],
          type: 'hierarchy'
        })
      }

    });

    this.hiearchyDropDown = {
      options: _.map(this.hierarchyList, (option: any) => {
        return option;
      })
    }
    return this.hierarchyHash;
  }


  prepareCustomParameter() {
    const fieldDefinitionsGetPromise = this.getFieldDefinitions()
    fieldDefinitionsGetPromise.then((response: any) => {
      if (response && !response.err) {
        this.fieldDefinitions = response.field_definitions;
        let brandDetail = Helpers.deepClone(this.brandDetails);
        brandDetail.field_definitions = Helpers.deepClone(this.fieldDefinitions);
        // Prepare for Transaction Details
        this.fieldDefinationHash = this.createHashBasedOnKey(brandDetail.field_definitions, "field_id", null, { "key": "custom_parameter_type", "value": 4 });

        this.prepareCustomParameterGroup(this.fieldDefinitions, brandDetail, this.brandTimezoneDetail);
        this.prepareAccordionElementList(this.fieldDefinitions);
        this.renderAccordions(Helpers.deepClone(this.fieldDefinitions), brandDetail);
      } else {
        this.fieldDefinitions = [];
        this.rightPaneloaded = true;
        this.loadingChange.emit(true)
      }
    })
  }

  prepareAccordionElementList(fieldDefintions) {
    if (_.get(fieldDefintions, "length")) {
      var lastUpdatedOn = null;
      var brandTimezoneDetail = this.getBrandZoneName(this.brandDetails);
      var fieldIds: any = [];
      _.each(fieldDefintions, (field: any) => {
        if (field && field.dom_options && field.dom_options.group_to_render) {
          fieldIds.push(field.dom_options.group_to_render)
        }
      })
      this.dynamicAccordions = _.filter(fieldDefintions, (fieldDefintion: any) => {
        lastUpdatedOn = _.get(this.feedData, ".feed.update_logs." + fieldDefintion.field_id + ".last_updated_on");
        if (lastUpdatedOn) {
          fieldDefintion["lastUpdatedOn"] = this.getDateBasedOnFormat(brandTimezoneDetail, lastUpdatedOn, "DD-MMM-YY HH:mm");
        }
        return ((_.get(fieldDefintion, "display_in") == "custom" && fieldIds.indexOf(fieldDefintion.field_id) < 0) ? fieldDefintion : false);
      });
    }
  }

  getBrandZoneName(brandDetails) {
    var brandOffset = 0;
    var brandTimezone: any = null;
    // If default_time_zone not present then fetch first brand from account and use the same.
    if (!brandDetails["default_time_zone"]) {
      brandDetails["default_time_zone"] = -330//accountLevelDefaultTimezone;
    }
    if (brandDetails && brandDetails.default_time_zone && brandDetails.default_time_zone.offset) {
      try {
        brandOffset = parseInt(brandDetails.default_time_zone.offset);
        brandOffset = brandOffset;
      } catch (err) {
        console.error("ERROR::getBrandTimezoneOffset::Helpers::" + JSON.stringify(err));
      }
    }

    if (brandDetails && brandDetails.default_time_zone && brandDetails.default_time_zone.timezone) {
      try {
        brandTimezone = brandDetails.default_time_zone.timezone;
        brandTimezone = brandTimezone;
      } catch (err) {
        console.error("ERROR::getBrandTimezoneName::Helpers::" + JSON.stringify(err));
      }
    }
    return { "name": brandTimezone, "offset": brandOffset };
  }

  renderAccordions(fieldDefintions, brandDetail) {
    var customParameterGroup = {};
    var dynamicAccordionGroupIds = _.flatten(_.map(this.dynamicAccordions, (accordian: any) => {
      return accordian.field_id
    }));
    var fieldDefinationHash = this.createHashBasedOnKey(Helpers.deepClone(fieldDefintions), "field_id", null, null);

    _.each(fieldDefintions, function (field) {
      if (field.visible == false) {
        field.show_in_inbox_detail = false;
      }
      // Custom Parameters to render in accordion
      // Don't render custom parameter in accordion if show_in_inbox_detail is false else show.
      if ((field.show_in_inbox_detail != false || field.visible != false) && (dynamicAccordionGroupIds.indexOf(field.field_id) != -1 || dynamicAccordionGroupIds.indexOf(field.group_id) != -1) && !field.hide_in_accordion) {
        // Update customParameterGroup if field's custom_parameter_type is 4(For Action Mgmt) and contain no group Id(This will give the parent group eg. closure)
        if (field.custom_parameter_type == 4 && !(field.group_id)) {
          if (!customParameterGroup[field["field_id"]]) {
            customParameterGroup[field["field_id"]] = field;
            customParameterGroup[field["field_id"]]["children"] = [];
          }
        } else if (field.group_id && field.custom_parameter_type && fieldDefinationHash[field["group_id"]]['visible'] != false) {
          // If field contain group id(The custom parameter with in parent group i.e., children)

          if (!customParameterGroup[field["group_id"]]) {
            customParameterGroup[field["group_id"]] = fieldDefinationHash[field["group_id"]];
            customParameterGroup[field["group_id"]]["children"] = [];
          }
          customParameterGroup[field["group_id"]]["children"].push(field);
        }
      }
    });
    var totalGroups = Object.keys(customParameterGroup).length;
    _.each(customParameterGroup, (value, key) => {
      this.renderDynamicAccordion(key, brandDetail, totalGroups);
    })
  }

  renderDynamicAccordion(groupKey, brandDetail, totalGroups) {
    var params = {
      "issueId": this.feedId,
      "brandDetail": brandDetail,
      "issueDetail": this.feedDetails,
      "accordionType": "dynamicAccordion",
      "elementId": "dynamicAccordion_" + this.feedId + "_" + groupKey,
      "action": {
        "action": "renderOnAccordion",
        "options": {
          "group_id": groupKey
        }
      },
      "totalGroups": totalGroups
    }
    setTimeout(() => {
      const services: any = {
        _helpers: this._helpers,
        LtmsDataSource: this.LtmsDataSource,
        lwComponentRenderer: this.lwComponentRenderer,
        _utils: this._utils,
        _uploadService: this._uploadService,
        _feedService: this._feedService,
        LwActionsExecutor: this.LwActionsExecutor,
        _ltmsEvent: this._ltmsEvent,
        _domSanitizer: this._domSanitizer,
        SecurityContext: SecurityContext
      }
      const ltmsCustomField: any = new CustomFieldRenderer(params, services)

      ltmsCustomField.addEventListener('group-data-updated', (groupDetail: any) => {
        this._ltmsEvent.emit("refresh-feed-detail");
      });

    }, 100);
  }

  prepareCustomParameterGroup(fieldDefinitions, brandDetail, brandTimezoneDetail) {
    var fieldDefinitions = fieldDefinitions;
    this.totalGroupsProcessed = 0;
    let parameterGroup = {};
    this.customParameterGroup = [];
    var issueDetail = this.feedDetails;
    var lastUpdatedOn = null;
    var fieldIds: any = [];
    _.each(fieldDefinitions, (field: any) => {
      if (field && field.dom_options && field.dom_options.group_to_render) {
        fieldIds.push(field.dom_options.group_to_render)
      }

      if (field.visible == false) {
        field.show_in_inbox_detail = false;
      }
      // Custom Parameters to render in accordion
      // Don't render custom parameter in accordion if show_in_inbox_detail is false else show.
      if ((field.show_in_inbox_detail != false || field.visible != false) && _.get(field, "display_in") != "custom" && fieldIds.indexOf(field.field_id) < 0 && !field.hide_in_accordion) {
        // Update customParameterGroup if field's custom_parameter_type is 4(For Action Mgmt) and contain no group Id(This will give the parent group eg. closure)
        if (field.custom_parameter_type == 4 && !(field.group_id)) {
          if (!parameterGroup[field["field_id"]]) {
            parameterGroup[field["field_id"]] = field;
            parameterGroup[field["field_id"]]["children"] = [];
            lastUpdatedOn = _.get(issueDetail, "feed.update_logs." + field["field_id"] + ".last_updated_on");
            if (lastUpdatedOn) {
              parameterGroup[field["field_id"]]["lastUpdatedOn"] = this.getDateBasedOnFormat(brandTimezoneDetail, lastUpdatedOn, "DD-MMM-YY HH:mm");
            }
          }
        } else if (field.group_id && field.is_custom_field) {                       // If field contain group id(The custom parameter with in parent group i.e., children)

          if (!parameterGroup[field["group_id"]]) {
            parameterGroup[field["group_id"]] = this.fieldDefinationHash[field["group_id"]];
            parameterGroup[field["group_id"]]["children"] = [];
          }
          parameterGroup[field["group_id"]]["children"].push(field);
        }
      }
    })


    // this.renderCustomParameter = renderCustomParameterBind.bind(this);
    this.customParameterGroup = Object.values(parameterGroup)
    var totalGroups = this.customParameterGroup.length;

    if (totalGroups == 0) {
      this.rightPaneloaded = true;
      this.loadingChange.emit(true)
    }
    _.each(this.customParameterGroup, (parameter: any, key: string) => {
      this.renderCustomParameter(parameter.field_id, brandDetail, totalGroups);
    })
  }

  renderCustomParameter(groupKey: any, brandDetail: any, totalGroups: number) {
    var params = {
      "issueId": _.get(this, "feedData.feed._id"),
      "brandDetail": brandDetail,
      "issueDetail": this.feedDetails,
      "elementId": "customParameter_" + _.get(this, "feedDetails._id") + "_" + groupKey,
      "action": {
        "action": "renderOnAccordion",
        "options": {
          "group_id": groupKey
        }
      },
      "totalGroups": totalGroups
    }

    setTimeout(() => {
      // var ltmsCustomField = new LtmsCustomFieldRenderer(params, $scope); 
      const services: any = {
        _helpers: this._helpers,
        LtmsDataSource: this.LtmsDataSource,
        lwComponentRenderer: this.lwComponentRenderer,
        _utils: this._utils,
        _uploadService: this._uploadService,
        _feedService: this._feedService,
        LwActionsExecutor: this.LwActionsExecutor,
        _ltmsEvent: this._ltmsEvent
      }
      const ltmsCustomField: any = new CustomFieldRenderer(params, services)
      // let ltmsCustomField: any = this.commonService.renderCustomFields(params)
      // Added by Bhunesh - Listening on Group rendered
      ltmsCustomField.addEventListener('group-rendered', (groupDetail) => {
        this.totalGroupsProcessed += 1;
        if (this.totalGroupsProcessed == totalGroups) {
          this.rearrangeAccordions();
        }
      });

      ltmsCustomField.addEventListener('group-data-updated', (groupDetail) => {
        this._ltmsEvent.emit("refresh-feed-detail");
      });

    }, 100);

  }


  rearrangeAccordions() {
    if (this.brandDetails && this.brandDetails.accordions_list && this.brandDetails.accordions_list.length) {
      const brandDetail = Helpers.brandDetails || this.brandDetails
      var squnc = _.map(brandDetail.accordions_list, (item) => { return item.sequence_no });
      if (!(squnc.includes(undefined))) {
        var nonOptionalElms: any = [];
        var optionalElms: any = [];
        let elements: any = document.querySelectorAll('#issueAssignmentContainer > div');
        if (elements && elements.length) {
          elements.forEach((elem: any) => {

            if (elem.hasAttribute("seq_no")) {
              nonOptionalElms.push(elem)
            } else {
              optionalElms.push(elem)
            }
          })
        }
        nonOptionalElms = nonOptionalElms.sort(this.compareSequence)

        const parent: any = document.getElementById('issueAssignmentContainer');
        if (parent) {
          nonOptionalElms.forEach((elm: any) => {
            if (elm) parent.appendChild(elm)
          })
          optionalElms.forEach((elm: any) => {
            if (elm) parent.appendChild(elm)
          })
        }

        this.rightPaneloaded = true;
        this.loadingChange.emit(true)
      } else {
        this.rightPaneloaded = true;
        this.loadingChange.emit(true)
      }
    }
  }

  compareSequence(a: any, b: any) {
    var a_seq = parseInt(a.getAttribute("seq_no"));
    var b_seq = parseInt(b.getAttribute("seq_no"));
    if (a_seq < b_seq) {
      return -1;
    }
    if (a_seq > b_seq) {
      return 1
    }
    return 0
  }

  getDateBasedOnFormat(offset: any, time: any, format?: string) {
    let dateformat = '"DD-MMM-YY HH:mm:ss"'
    if (format) {
      dateformat = format
    }
    moment.utc(time).utcOffset(-offset).format(dateformat);
  }

  createHashBasedOnKey(list: any, key: string, value?: any, filter?: any) {
    var hash = {};
    _.each(list, (elem: any) => {

      // Ignore elem which match with filter. Filter contains key and value.
      // In case elem contains filter's key and have filter's value then ignore.
      // It will add element if filter not present.
      if (!(filter && filter["key"] && filter["value"] && elem[filter["key"]] && elem[filter["key"]] == filter["value"])) {
        hash[elem[key]] = (value) ? elem[value] : elem;

        // This is to handle categories with children
        if (elem["children"]) {
          hash = Object.assign(hash, this.createHashBasedOnKey(elem["children"], key, value));
        }
      }
    });
    return hash;
  }

  getFieldDefinitions() {
    return new Promise((resolve) => {
      const params: any = {
        issue_id: this.feedId,
        brand_id: this.brandDetails._id,
        type: 1,
        source: "inbox_detail"
      }
      this._feedService.getFieldDefinitions(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        if (response && response.code == 0 && response.data.field_definitions && response.data.field_definitions.length) {
          resolve({ err: null, field_definitions: response.data.field_definitions })
        } else {
          resolve({ err: "IssueFilterAssignmentComponent-getFieldDefinitions-problem getting field_definitions", field_definitions: [] });
        }
      })
    })
  }

  getHierarchyStack() {
    // this.issueDetail
    var tags = this.feedDetails["tags"];
    var hierarchyStack = {};
    // The tags which contains 'tag_private_group_' are hierarchy information
    var hierarchy_tag_text = "tag_private_group_h_";
    var hierarchy_key: any = null;
    for (let key in tags) {
      hierarchy_key = null;
      if (key.indexOf(hierarchy_tag_text) >= 0) {
        // the whole key will be replaced by the text mentioned in hierarchy_tag_text(tag_private_group_h_)
        // append 'h_', as this will also be replaced will the replace command
        hierarchy_key = 'h_' + key.replace(hierarchy_tag_text, '')
        if (!(hierarchy_key == "hierarchy")) { // Ignore hierarchy as it is not in use.
          hierarchyStack[hierarchy_key] = tags[key];
        }
      }
    }
    if (tags.length) {
      return hierarchyStack;
    } else {
      return;
    }

  }

  selectHiearchy(event: any, isAssginee: boolean, isFollower: boolean) {
    this.selectedHierarchy = event.detail;
    if (isAssginee) {
      this.assigneeSelectedLevel = event.detail
      this.managerSearch.isDisabled = false;
    }
    if (isFollower) {
      this.followerSelectedLevel = event.detail
      this.followerSearch.isDisabled = false;
    }
    this.initAssigneeSearch(isAssginee, isFollower);
    this.dropdowns.hierarchy = false;
  }

  initAssigneeSearch(isAssginee: boolean, isFollower: boolean) {
    let url = this._feedService.getManagerSearchUri();
    if (this.isRoleBased) {
      url = this._feedService.getRoleBasedSerchUri();
    }

    if (isAssginee) {
      this.managerSearch = {
        selectedOption: {},
        placeholder: "Please search and select",
        searchfield: "search_text",
        options: [],
        isDisabled: this.isAssigneeDisabled,
        api: {
          url: url,
          method: "Get",
          isRoleBased: this.isRoleBased,
          parser: this.managerSearchDataProcessor,
          paramters: this.getSearhParams(this.isRoleBased)
        }
      }

    }
    this.accordian.assignee = true
    if (isFollower) {
      this.followerSearch = {
        selectedOption: {},
        placeholder: "Please search and select",
        searchfield: "search_text",
        options: [],
        isDisabled: this.isFollowerDisabled,
        api: {
          url: url,
          method: "Get",
          isRoleBased: this.isRoleBased,
          parser: this.managerSearchDataProcessor,
          paramters: this.getSearhParams(this.isRoleBased)
        }
      }

    }
    this.accordian.follower = true
  }

  getSearhParams(isRoleBased: boolean) {
    if (isRoleBased) {
      return {
        "brand_id": this.brandDetails._id,
        "level": this.selectedHierarchy.value,
        "type": 1, // Get roles based on levels
        "page_number": 1,
        "limit": 10
      }
    } else {
      return {
        brand_id: this.brandDetails._id,
        "field_to_search": "email_address",
        "source_type": 2,
        page_number: 1,
        limit: 10,
        search_for_verified_mgrs: true,
        search_type: 4,
        hierarchy_stack: this.getHierarchyStack()
      }
    }
  }



  checkIfRoleBased() {
    if (_.get(this, "brandDetail.action_management_configuration.isRoleBasedAssignee") && _.get(this, "brandDetail.is_single_touchpoint_setup")) {
      this.isRoleBased = true;
    } else {
      this.isRoleBased = false;
    }

  }

  managerSearchDataProcessor(response: any) {
    let managersList: any = []
    if (this.isRoleBased && response.code == 0 && response.data.data && response.data.data.length) {
      _.each(response.data.data, (value: string) => {
        managersList.push({
          value: value,
          name: value
        })
      })
    } else if (response.code == 0 && response.data.managers && response.data.managers.length) {
      _.each(response.data.managers, (managers: any) => {
        managersList.push({
          value: managers._id,
          _id: managers._id,
          name: managers.email_address
        })
      })
    }

    return managersList;
  }

  onAssigneeSelect(event: any) {
    this.selectedAssignee = event.detail;
    if (!_.isEmpty(this.selectedAssignee)) {
      this.isAssigneeButtonEnabled = true;
    } else {
      this.isAssigneeButtonEnabled = false;
    }
  }

  onFollowerSelect(event: any) {
    this.selectedAssignee = event.detail
    if (!_.isEmpty(this.selectedAssignee)) {
      this.isFollowerButtonEnabled = true;
    } else {
      this.isFollowerButtonEnabled = false;
    }
    // this.followers.push(event.detail)
    // this.prepareFollower()
  }

  removeAssigneeAndFollower(mgrDetail, tagType, isRoleBased) {
    this.selectedAssignee = mgrDetail;
    this.isAssigneeButtonEnabled = false;
    this.isFollowerButtonEnabled = false;
    this.updateAssigneeAndFollower(true, tagType, isRoleBased);
    this.selectedAssignee = {};

  }

  updateAssigneeAndFollower(isRemoveAssignee, tagType, isRoleBased) {
    // if (!false) {
    //   let assignee = this.clone(this.selectedAssignee);
    //   // assignee.hierarchy_level = this.selectedHierarchy.value;
    //   this.followers.push(assignee);
    //   this.selectedHierarchy = {};
    //   this.initAssigneeSearch(false, true);
    // } else {
    //   let assignee = this.clone(this.selectedAssignee);
    //   // assignee.hierarchy_level = this.selectedHierarchy.value;
    //   this.assigneeList.push(assignee);
    //   this.selectedHierarchy = {};
    //   this.initAssigneeSearch(true, false);
    // }
    this.managerSearch.selectedOption = {};
    this.followerSearch.selectedOption = {};
    let eventToTrigger: string = '';
    let actionSelected: string = '';
    if (tagType == 4) {
      eventToTrigger = "LW_RESPONSE_ASSIGNEE_CHANGED";
      this.actionSelected = "ASSIGNEE_CHANGED";
    } else if (tagType == 8) {
      eventToTrigger = "LW_RESPONSE_FOLLOWERS_CHANGED";
      this.actionSelected = "ASSIGNEE_CHANGED";
    }

    var feedDetail = _.get(this.feedData, "feed") ? _.get(this.feedData, "feed") : {};

    feedDetail.tags = this.feedData.tags
    var brandDetail = Helpers.brandDetails || this.brandDetails;
    feedDetail.brandDetail = Helpers.deepClone(brandDetail);
    // if (this.fieldDefinitions && this.fieldDefinitions.length) {
    //   feedDetail.brandDetail.field_definitions = Helpers.deepClone(this.fieldDefinitions)
    // }
    //var ltmsEventExecutor = new LWEventsExecutor()
    if (this.is_action_workflow_enabled && !_.isEmpty(feedDetail) && !isRemoveAssignee) {
      var brandId = _.get(brandDetail, "_id");
      var feedId = _.get(this, "feedData.feed._id");
      const params: any = {
        brand_id: this.brandDetails._id,
        event_name: eventToTrigger,
        feed_detail: Helpers.deepClone(feedDetail)
      }
      this._feedService.getUiRuleStatus(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response) => {
        if (response && response.code == 0 && response.data.data.actions) {
          this.LwActionsExecutor.execute(response.data.data.actions, Helpers.deepClone(feedDetail), this.serviceToPass, (err, success) => {
            if (!err) {
              this.assignUnassignIssueToManager(isRemoveAssignee, tagType, isRoleBased);
            }
          })
        } else {
          console.warn("NO ui Rule found");
        }
      });


    } else {
      this.assignUnassignIssueToManager(isRemoveAssignee, tagType, isRoleBased);
    }

  }

  assignUnassignIssueToManager(isRemoveAssignee, tagType, isRoleBased) {
    var removalRestrictionValidation = true;
    var mgrDetail = Helpers.deepClone(this.selectedAssignee);
    var key = (tagType == 4) ? "assignee" : "follower";
    var defaultText = (key == "assignee") ? "Assignee" : "Follower";
    this.selectedAssignee = {}
    this.isAssigneeButtonEnabled = false;
    this.isFollowerButtonEnabled = false;
    // var displayText = (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig[key]) ? this.accordionVisibilityFinalConfig[key]["display_name"] : defaultText;
    var displayText = defaultText
    if (!_.isEmpty(mgrDetail)) {
      this.assigningIssue = true;
      this.assigningRoleIssue = true;

      let details = (_.isObject(mgrDetail)) ? mgrDetail : Helpers.deepClone(mgrDetail);
      if (!isRoleBased) {
        details.email_address = details.name;
      }

      let issueAssignedTo: any = [];
      let keyToUpdate: any = null;
      let successMsgForUpdate: any = null;
      if (tagType == 4) {
        // this.assigningRoleIssue = false;
        //changed according to rolebased need to check.
        if (isRoleBased) {
          keyToUpdate = 'role_assigned_to';
          successMsgForUpdate = displayText || "Assignee";
          issueAssignedTo = _.get(this, "roleBasedAssigneeList") || [];
        } else {
          keyToUpdate = 'assigned_to_id_list';
          successMsgForUpdate = displayText || "Assignee";
          issueAssignedTo = _.get(this, "feedData.feed.assigned_to_id_list") || [];
        }

      } else if (tagType == 8) {
        if (isRoleBased) {
          keyToUpdate = 'roles_followed_by';
          successMsgForUpdate = displayText || "Follower";
          issueAssignedTo = _.get(this, "roleBasedFollowerList") || [];
        } else {
          keyToUpdate = 'followers_id_list';
          successMsgForUpdate = displayText || "Follower";
          issueAssignedTo = _.get(this, "feedData.feed.followers_id_list") || [];
        }
      }

      // For rolebased parameter to pass will be according to role based assignee
      var roleBasedDetails: any = isRoleBased ? {} : null;
      if (isRoleBased) {
        if (!isRemoveAssignee) {
          const level = this.selectedHierarchy.value || details.level;
          roleBasedDetails[level] = details.value
          if (tagType == 8) {
            roleBasedDetails = {
              level: level,
              value: details.value
            }
          }
        } else {
          roleBasedDetails = details;
        }
      }


      var assigneeId: any = isRoleBased ? null : details["_id"];

      if (!(issueAssignedTo.indexOf(assigneeId) > -1) || isRemoveAssignee || isRoleBased) {
        var isValid = true;
        // Checking duplicate entry for role based .
        if (isRoleBased && !isRemoveAssignee) {
          if (tagType == 4) {
            var levelId = Object.keys(details)[0];
            var groupName = Object.values(details)[0];
            if (this.roleBasedAssigneeList != undefined || this.roleBasedAssigneeList != null) {
              if (this.roleBasedAssigneeList.length > 0) {
                if (levelId == this.roleBasedAssigneeList[0]["level"] && this.roleBasedAssigneeList[0]["value"] == groupName) {
                  isValid = false;
                  Helpers.smallAlertBox("Error", "Please select a new role, Issue already assigned to selected role.", "error");
                  // $("#lwIssueAssigneeESFilter option[value='" + roleBasedLevel + "']").remove();
                  // this.assigningRoleIssue = true;
                  // resetSelectById("lwIssueAssigneeLevelRoleESFilter");
                  // 
                  // resetSelectById("lwIssueAssigneeESFilter");
                }
              }
            }
          } else if (tagType == 8) {
            if (this.roleBasedFollowerList != undefined || this.roleBasedFollowerList != null) {
              if (this.roleBasedFollowerList.length > 0) {
                _.every(this.roleBasedFollowerList, function (role) {
                  if (role.level == details.level && role.value == details.value) {
                    isValid = false;
                    return false;
                  }
                  return true;
                })
                if (!isValid) {
                  Helpers.smallAlertBox("Warning", "Please select a new role,issue already followed by selected Role.", "warn");
                  // resetSelectById("lwIssueFollowerLevelFilter");
                }
              }
            }
          }
        }

        if (defaultText == 'assignee') {
          if (!isRoleBased) {
            // validation for removal self assignee in assignee accordion (validation when assigned_to_id_list same as loggedin manager.)
            removalRestrictionValidation = _.get(this.accordionsMap, 'assignee.restrict_self_removal') ? (mgrDetail["_id"] != this.loggedInManger._id) : true;
          } else {
            if (isRemoveAssignee) {
              removalRestrictionValidation = _.get(this.accordionsMap, 'assignee.restrict_self_removal') ? (!(this.loggedInMangerAccessDetails[mgrDetail['level']] && this.loggedInMangerAccessDetails[mgrDetail['level']].indexOf(mgrDetail['value']) != -1)) : true;
            } else {
              // At the time of addition of role level, check required for restrict self removal flag of assignee accordion.
              if (_.get(this.accordionsMap, 'assignee.restrict_self_removal')) {
                var managerLevel = Object.keys(mgrDetail)[0];
                removalRestrictionValidation = (this.loggedInMangerAccessDetails[managerLevel] && this.loggedInMangerAccessDetails[managerLevel].indexOf(mgrDetail[managerLevel]) != -1);
              }
            }
          }
        }

        if (isValid && removalRestrictionValidation) {
          this._feedService.assignUserToFeed(_.get(this, "feedData.feed._id"), [assigneeId], isRemoveAssignee, tagType, isRoleBased, [roleBasedDetails], this.feedData.feed.brand_id).pipe(
            takeUntilDestroyed(this.destroyRef)
          ).subscribe((response) => {

            this.assigningIssue = false;
            this.assigningRoleIssue = false;
            var responseCode = _.get(response, "data.code");
            this.assigneeSelectedLevel = {}
            this.followerSelectedLevel = {}
            this.managerSearch.selectedOption = {}
            this.followerSearch.selectedOption = {}

            if (_.get(response, "data.code") == 0) {

              if (isRemoveAssignee) {
                // Unassigned issue/feed
                if (!isRoleBased) {
                  var index = issueAssignedTo.indexOf(assigneeId);
                  issueAssignedTo.splice(index, 1);
                } else {
                  issueAssignedTo = [];
                  this.feedData.feed.role_assigned_to = {};
                  this.roleBasedAssigneeList = [];

                }
                if (tagType == 4) {
                  if (!isRoleBased) {
                    const index = this.feedDetails.assigned_to_id_list.indexOf(assigneeId);
                    this.feedDetails.assigned_to_id_list = _.filter(this.feedDetails.assigned_to_id_list, (id: string) => { return id != assigneeId });
                    this.feedData.feed.assigned_to_id_list = this.feedDetails.assigned_to_id_list;
                  }
                  Helpers.smallAlertBox("Success", successMsgForUpdate + " updated successfully.", "Success")
                } else if (tagType == 8) {
                  if (!isRoleBased) {
                    const index = this.feedDetails.followers_id_list.indexOf(assigneeId);
                    this.feedDetails.followers_id_list = _.filter(this.feedDetails.followers_id_list, (id: string) => { return id != assigneeId });
                    this.feedData.feed.followers_id_list = this.feedDetails.followers_id_list;
                  } else {
                    this.feedDetails.roles_followed_by = _.filter(this.feedDetails.roles_followed_by, (role: any) => {
                      return (role.level != roleBasedDetails.level && role.value != roleBasedDetails.value)
                    })
                  }

                  Helpers.smallAlertBox("Success", successMsgForUpdate + " updated successfully.", "Success")
                }
              } else {

                if (tagType == 4) {
                  // Update Hash which contains list of assignees/ Followers
                  if (!isRoleBased) {
                    this.assigneeHash[assigneeId] = details;
                    if (this.feedData && this.feedData.managers) {
                      this.feedData.managers.push(details);
                    }
                  } else {
                    this.assigneeHash = details;
                    if (this.feedData && !_.isEmpty(this.feedData.feed.role_assigned_to)) {
                      // this.issueDetail.managers = [];
                      this.feedData.managers.push(details);
                      this.feedData.feed.role_based_assignee_id_list = response.data.managers_detail;
                      // this.roleBasedAssigneeLevel = Object.keys(this.roleBasedAssigneeList)[0];
                      // roleBasedObject[this.issueDetail.feed.role_assigned_to["level"]] = this.issueDetail.feed.role_assigned_to["value"];
                      this.roleBasedAssigneeList = [this.roleBasedObject];
                    }
                  }
                } else if (tagType == 8) {

                }


                // Assigned issue/feed to Manager
                // assigneeToUpdate = {};
                // In case no assignee for the issue, initialize empty array
                if (!this.feedData.feed[keyToUpdate]) {
                  this.feedData.feed[keyToUpdate] = [];
                }
                if (!_.hasIn(this.feedDetails, keyToUpdate)) {
                  this.feedDetails[keyToUpdate] = []
                }

                if (!isRoleBased) {
                  // this.feedData.feed[keyToUpdate].push(assigneeId);
                  this.feedDetails[keyToUpdate].push(assigneeId);
                } else {
                  this.feedData.feed[keyToUpdate] = {};
                  // this.issueDetail.feed[keyToUpdate].push(details);
                  for (key in roleBasedDetails) {
                    var levelId = key;
                    this.roleBasedAssigneeList = [{ "level": key, "value": roleBasedDetails[key], "text": this.hierarchyHash[key] }]
                  }
                }



                // Reset select
                if (tagType == 4) {
                  this.managerSearch.selectedOption = {};
                  // this.assigningRoleIssue = true;
                  // $("#lwIssueAssigneeESFilter option[value='" + assigneeId + "']").remove();
                  // $("#lwIssueAssigneeESFilter option[value='" + roleBasedLevel + "']").remove();
                  // $("#lwIssueAssigneeLevelRoleESFilter option[value='" + roleBasedLevelId + "']").remove();
                  Helpers.smallAlertBox("Success", successMsgForUpdate + " updated successfully.", "Success");

                  // showing alert box for follower added when assignee is added (EasyFollow)
                  if ((_.get(response, "data.triggerNature") == "easyFollow")) {
                    setTimeout(function () {
                      Helpers.smallAlertBox("Success", "Follower  updated successfully.", "Success");
                    }, 1000)
                  }
                } else {
                  this.followerSearch.selectedOption = {};
                  if (!isRoleBased) {
                    const index = this.feedDetails.followers_id_list.indexOf(assigneeId);
                    if (index < 0) {
                      this.feedDetails.followers_id_lis.push(assigneeId);
                      this.feedData.feed.followers_id_list.push(assigneeId);
                    }

                  }

                  // $("#lwIssueFollowerESFilter option[value='" + assigneeId + "']").remove();
                  Helpers.smallAlertBox("Success", successMsgForUpdate + " updated successfully.", "Success");
                }
              }
              // LtmsEventListener.fire("refresh-issue-history");
              // LtmsEventListener.fire("reload-feed-right-panel-filter");
              this._ltmsEvent.emit("refresh-feed-detail")
              // this.rightPaneloaded = false;
            } else if (responseCode == 4 || responseCode == 4022) {
              Helpers.smallAlertBox("Error", successMsgForUpdate + " with name already exists.", "error");
            } else {
              Helpers.smallAlertBox("Error", response.data.error_message, "error");
            }
            // Reset assignee dropdown
            // resetSelectById("lwIssueAssigneeESFilter");
            // resetSelectById("lwIssueFollowerESFilter");
            // $("#lwIssueAssigneeESFilter option[value='" + roleBasedLevel + "']").remove();
          });
        } else {
          // Check for removalRestrictionValidation
          if (isRoleBased && !removalRestrictionValidation) {
            Helpers.smallAlertBox("Warning", "Cannot assign to other level as restrict self assignee(s) mode in On.", "warn");
          } else if (!removalRestrictionValidation) {
            Helpers.smallAlertBox("Warning", "Cannot assign to other manager as restrict self assignee(s) mode in On.", "warn");
          }
        }
      } else {
        this.assigningIssue = false;
        this.assigningRoleIssue = false;

        if (tagType == 4) {
          Helpers.smallAlertBox("Error", "Please select a new user, issue already assigned to selected user.", "error");
        } else if (tagType == 8) {
          Helpers.smallAlertBox("Error", "Please select a new user,issue already followed by selected user.", "error");
        }
        //Reset assignee dropdown
        // resetSelectById("lwIssueAssigneeESFilter");
        // resetSelectById("lwIssueFollowerESFilter");
      }
    } else {
      Helpers.smallAlertBox('Warning', "Please select " + displayText, "Warning", "warn");
    }
  }



  updateAssigneeDetails(details: any, isRemove: boolean, isRoleBased: boolean) {
    if (isRemove) {

    }
  }


  addTag(event: any) {
    if (event.target.value && event.target.value != '') {
      this.tagList.push(event.target.value);
    }
    event.target.value = '';

  }



  isTagButtonEnabled: boolean = false;


  getTagsList(event: any) {
    event.preventDefault()
    var tagText = event.target.value.trim();
    this.isTaglistEnabled = true;
    if (tagText.trim() == "") {
      this.showTags = false;
      this.tagList = [];
      this.issueTagText = ''
      this.isTagButtonEnabled = false;
    } else {
      this.showTags = true;
      this.isTagButtonEnabled = true
      this.tagList = _.filter(Helpers.deepClone(this.tags), (tag: any) => {
        return (tag && tag.name && tag.name.toLowerCase().indexOf(tagText.toLowerCase()) >= 0)
      })
      // $timeout(function() {
      //     $('#tagList > li').each(function() {
      //         var text = $(this).text().toLowerCase();
      //         !(text.indexOf(valThis) >= 0) ? $(this).hide(): $(this).show();
      //     });
      // }, 0);

    };
  }
  addNotes(event: any) {
    this.notes.push({
      name: "Pankaj Rajwade",
      created_date: new Date().toISOString(),
      text: _.get(event, 'target.value', '')
    });
    event.target.value = '';
  }

  prepareCategoryData() {
    this.isCategoryEnabled = false;
    this.isSubCatoryEnabled = false;
    const params: any = {
      issue_id: this.feedId,
      brand_id: this.brandDetails._id
    }
    this._feedService.getCategoryList(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (response.code == 0 && response.data.category_list && !_.isEmpty(response.data.category_list)) {
        this.processCategories(response.data.category_list)
      }
    })
  }

  processCategories(list: any) {
    console.log()
    this.categoryDropDown = {
      options: _.map(_.filter(list, (item: any) => {
        return (item.visible != false);
      }), (value: any) => {
        value.value = value.uuid
        return value;
      })
    }
    const categoryDetails:any = _.get(this.feedData, "category_details")
    list = [...list,...categoryDetails]
    this.categoryListMap = this.createHashBasedOnKey(list, 'uuid', null)
    if (this.feedDetails.category_id_list && this.feedDetails.category_id_list.length) {
      let selectedCategoryId = this.feedDetails.category_id_list[0];
      let selectedSubCategoryId = this.feedDetails.category_id_list[1];
      this.isCategoryEnabled = true;
      this.selectedCategories = {
        selectedCategoryId: selectedCategoryId,
        selectedSubCategoryId: selectedSubCategoryId,
        "category": (selectedCategoryId && this.categoryListMap[selectedCategoryId]) ? this.categoryListMap[selectedCategoryId] : {},
        "sub_category": (selectedSubCategoryId && this.categoryListMap[selectedSubCategoryId]) ? this.categoryListMap[selectedSubCategoryId] : {},
      }
      if (selectedCategoryId && this.categoryListMap[selectedCategoryId] && this.categoryListMap[selectedCategoryId].children && this.categoryListMap[selectedCategoryId].children.length) {
        this.subCategoryDropDown = {
          options: _.map(this.categoryListMap[selectedCategoryId].children, (value: any) => {
            value.value = value.uuid
            return value;
          })
        }
        this.isSubCatoryEnabled = true;
      }

    } else {
      this.isCategoryEnabled = true;
    }



    // _.each(list, (category: any) => {
    //   this.categoryList.push(category);
    //   if (category.children && category.children.length) {
    //     _.each(category.children, (subCategory: any) => {
    //       this.categoryList.push(subCategory);
    //     })
    //   }
    // });
  }



  onFileSelect(event: any) {
    const files = _.get(event, 'target.files', []);
    _.each(files, (file: any) => {
      this.files.push(file)
    })

  }

  addFiles() {
    this.attachments = _.concat(this.attachments, this.files);
    const el: any = document.getElementById('controller-attachment')
    this.files = [];
    el.value = '';
  }

  onStatusChange() {
    this.actionSelected = "STATUS_CHANGED";
    if (this.selectedStatus.uuid && this.feedDetails.status_id_list.indexOf(this.selectedStatus.uuid) < 0) {
      const event_name = "LW_RESPONSE_STATUS_CHANGED";
      let feed = this.clone(this.feedDetails);
      var oldStatusValue = Helpers.deepClone(feed.status_id_list);
      feed.status_id_list = [this.selectedStatus.uuid]
      feed.brand_id = this.brandDetails._id;
      const brandDetail = Helpers.brandDetails || this.brandDetails
      feed.brandDetail = this.clone(brandDetail);
      // if (this.fieldDefinitions && this.fieldDefinitions.length) {
      //   feed.brandDetail.field_definitions = Helpers.deepClone(this.fieldDefinitions)
      // }

      feed.tags = this.clone(this.feedData.tags)
      const params: any = {
        brand_id: this.brandDetails._id,
        event_name: event_name,
        feed_detail: feed
      }
      // var LwActionExecutor = new LwActionsExecutor()  
      if (this.is_action_workflow_enabled) {
        this._feedService.getUiRuleStatus(params).pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe((response: any) => {
          this.LwActionsExecutor.execute(response.data.data.actions, this.clone(feed), this.serviceToPass, (err, success) => {
            if (!err) {
              this.assignStatus(this.selectedStatus);
            } else {
              // $("#selectFeedStatus").val('');
              this.feedDetails.status_id_list = oldStatusValue;
              this.selectedStatus = this.statusHash[oldStatusValue[0]]
            }
          })
        })
      } else {
        this.assignStatus(this.selectedStatus);
      }

      this.dropdowns.status = false;
    }else{
      if(!this.selectedStatus.uuid){
        Helpers.smallAlertBox("Error", "Please select a status.", "error");
      }else if(this.feedDetails.status_id_list.indexOf(this.selectedStatus.uuid) >= 0){
        Helpers.smallAlertBox("Error", "Status already assigned to the issue.", "error");
      }
    }
  }

  assignStatus(status) {
    this.getRCAStatus(status, (isRCANeeded: boolean) => {
      if (isRCANeeded) {
        this.setStatus(status, 1);
      }
    });
  }

  getRCAStatus(status: any, cb: any) {
    var rcaNeeded = _.get(this.brandDetails, "module_configuration.feedback.submodules.feedsnew.submodules.rca_needed.visible");
    if (rcaNeeded && status.uuid == "c71a8524-7fc4-49d3-894a-2555dcc6ed07") {
      const rcaTextEl: any = document.getElementById('issueRCAText');
      const issueClosureRCALabelEl: any = document.getElementById('issueClosureRCALabel');
      const issueClosureRCAModal: any = document.getElementById('issueClosureRCAModal');
      if (rcaTextEl) {
        rcaTextEl.value = ''
      }
      if (issueClosureRCALabelEl) {
        issueClosureRCALabelEl.innerHTML = "Please Provide Comments:"
      }
      if (issueClosureRCAModal) {
        issueClosureRCAModal.classList.add('show');
      }
      // $('#issueRCAText').val('');
      // Need to set header as we are using same for custom parameter where, we modify the header.
      // $("#issueClosureRCALabel").html("Please Provide Comments:");
      // $('#issueClosureRCAModal').modal({ "keyboard": false, "backdrop": false });
      cb(false);
    } else {
      cb(true);
    }
  }

  setStatus(status, tagType) {
    var idList;
    if (tagType == 2) {
      idList = status;
    } else {
      idList = [status["uuid"]];
    }
    this._feedService.assignTagsToFeed(_.get(this.feedData, "feed._id"), tagType, idList, null).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      var responseCode = _.get(response, "data.code");
      if (responseCode == 0) {
        this.feedData.status_details = [this.statusHash[status["uuid"]]];
        this.oldStatus = idList;
        var displayText;
        if (tagType == 1) {
          displayText = (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig['status']) ? this.accordionVisibilityFinalConfig['status']["display_name"] : "Status";
        }
        else if (tagType == 2) {
          displayText = (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig['category']) ? this.accordionVisibilityFinalConfig['category']["display_name"] : "Category";
        } else {
          displayText = null;
        }
        // Reset element
        // $('#selectFeedStatus').prop('selectedIndex', 0)
        this._ltmsEvent.emit("refresh-issue-history");
        this._ltmsEvent.emit("reload-feed-right-panel-filter");
        this._ltmsEvent.emit("refresh-feed-detail")
        // this.rightPaneloaded = false;

        // showing alert box for follower added when status is updated (EasyFollow)
        if ((_.get(response, "data.triggerNature") == "easyFollow")) {
          setTimeout(function () {
            Helpers.smallAlertBox("Success", "Follower" + " updated successfully.", "Success");
          }, 1000)
        }
        if (tagType) {
          this.feedDetails.status_id_list = [this.selectedStatus.uuid];
          this.feedData.feed = this.feedDetails
        }
        Helpers.smallAlertBox("Success", (displayText || "Status") + " updated successfully.", "Success");
      } else if (responseCode == 4 || responseCode == 4022) {
        Helpers.smallAlertBox("Error", (displayText || "Status") + " with name already exists.", "error");
      } else {
        Helpers.smallAlertBox("Error", _.get(response, "data.error_message") || "Something went wrong.", "error");
      }
    });
  }

  selectStatus(event: any, status: any) {
    event.preventDefault();
    this.selectedStatus = status;
  }

  toggleDropDown(event: any, field_key: string) {
    event.stopPropagation();
    for (let key in this.dropdowns) {
      if (key == field_key) {
        this.dropdowns[key] = !this.dropdowns[key]
      } else {
        this.dropdowns[key] = false
      }
    }
  }


  createHashMap(list: any, key: string) {
    let map = {};// new Map();
    _.each(list, (obj: any) => {
      if (obj[key]) {
        map[obj[key]] = obj;
        // map.set(obj[key],obj;
      }
    });
    return map;
  }

  clone(data: any) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    } else {
      return data
    }
  }
  isNotesButtonEnabled: boolean = false;
  onNoteTextChange(event: any, noteText: string) {
    event.preventDefault()
    if (noteText.trim() == '') {
      this.noteText = '';
      this.isNotesButtonEnabled = false;
    } else {
      this.isNotesButtonEnabled = true
    }
  }

  createNote(event: any, text: any, isRcaForm: boolean, cb?: any) {
    event.preventDefault();
    if (!text) {
      text = event.target.value;
    }
    const noteEl: any = document.getElementById('ltms-feed-note-text');
    var params: any = {}
    let displayText: string = "Notes"
    this.isNotesButtonEnabled = false;
    // No HTML tags; specials only when attached to letters/digits (before or after); must include alphanumerics
    const noteRegex = /^(?![\s\S]*<\/?\s*[a-zA-Z][^>]*>)(?![\s\S]*(?:^|\s)[^A-Za-z0-9\s]+(?=\s|$))(?=[\s\S]*[A-Za-z0-9])[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F]{1,1000}$/;
    const originalText = String(text || '');
    if (originalText.trim().length > 0 && noteRegex.test(originalText)) {
      text = this._domSanitizer.sanitize(SecurityContext.HTML, originalText) as string;
      if (!text || !String(text).trim().length) {
        if (noteEl) {
          noteEl.value = "";
        }
        if (cb) {
          cb(false);
        } else {
          Helpers.smallAlertBox("Warning", "Please enter valid " + displayText.toLowerCase() + " to add.", "warn");
        }
        return;
      }
      //9293190319LP- if RCA form is calling create note then send newly selected status
      var status = "Undefined";
      if (isRcaForm && this.selectedStatus.uuid && this.statusHash[this.selectedStatus.uuid] && this.statusHash[this.selectedStatus.uuid].name) {
        status = this.statusHash[this.selectedStatus.uuid].name;
      } else if (_.get(this, "feedData.status_details.0.name")) {
        status = _.get(this, "feedData.status_details.0.name")
      }
      // status = isRcaForm && && statusHash[$('#selectFeedStatus option:selected')[0].value].name ? statusHash[$('#selectFeedStatus option:selected')[0].value].name : (_.get(this, "issueDetail.status.name"));
      if (isRcaForm == true) {
        params = {
          "feed_id": _.get(this, "feedData.feed._id"),
          "brand_id": this.brandDetails._id,
          "text": text,
          "status_name": status,
          "type": 1,
          "note_generation_from_status": true  // flag to confirm that note creation happened on status change and not a normal note creation
        }
      } else {
        params = {
          "feed_id": _.get(this, "feedData.feed._id"),
          "brand_id": this.brandDetails._id,
          "text": text,
          "status_name": status,
          "type": 1
        }
      }
      // var ltmsEventExecutor = new LWEventsExecutor()
      var issueDetail = _.get(this.feedDetails, "_id") ? Helpers.deepClone(this.feedDetails) : Helpers.deepClone(this.feedData.feed);
      issueDetail.tags = this.feedData.tags
      const brandDetail = Helpers.brandDetails || this.brandDetails
      issueDetail.brandDetail = Helpers.deepClone(brandDetail);
      if (!isRcaForm && this.is_action_workflow_enabled) {
        var brandId = _.get(this.brandDetails, "_id");
        //var feedId = _.get(this, "issueDetail.feed._id");
        const noteParams = {
          brand_id: this.brandDetails._id,
          event_name: "LW_NOTE_ADDED",
          feed_detail: Helpers.deepClone(this.feedDetails)
        }
        this._feedService.getUiRuleStatus(noteParams).pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe((response) => {
          if (response && response.code == 0 && response.data.data.actions) {
            this.LwActionsExecutor.execute(response.data.data.actions, Helpers.deepClone(issueDetail), this.serviceToPass, (err, success) => {
              if (!(err && err.length)) {
                this.addNote(params, Helpers.deepClone(this.loginResponse), () => {
                  if (noteEl) {
                    noteEl.value = ""
                  }
                  this.noteText = '';

                });
              } else {
                this.noteText = '';
                if (noteEl) {
                  noteEl.value = ""
                }

              }
            })
          } else {
            //promise.resolve({ err: "No UI Rule found", uiRules: [] });
            console.warn("NO ui Rule found");
          }
        });

      } else {
        this.addNote(params, Helpers.deepClone(this.loginResponse), (hasAdded) => {
          if (cb) {
            cb(hasAdded)
          } else {
            this.noteText = ''

          }
        });
      }

    } else {
      if (noteEl) {
        noteEl.value = ""
      }
      
      if (cb) {
        cb(false);
      } else if (originalText.trim().length > 0 && !noteRegex.test(originalText)) {
        Helpers.smallAlertBox("Warning", "Please enter valid " + displayText.toLowerCase() + " to add.", "warn");
      } else {
        Helpers.smallAlertBox("Warning", "Please enter " + displayText.toLowerCase() + " to add.", "warn");
      }

    } 
  }

  addNote(params, loginResponse, cb) {
    this._feedService.createNote(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (response && _.get(response, 'code') == 0) {

        // var displayText = (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig['notes']) ? this.accordionVisibilityFinalConfig['notes']["display_name"] : "Notes";
        const noteEl: any = document.getElementById('ltms-feed-note-text');
        if (noteEl) {
          noteEl.value = ""
        }
        // $('#issueNoteText').trigger('change');
        // $('#issueDetailAddNote').removeAttr('disabled');
        if (_.get(response, "note_id")) {
          params.created_date = new Date();
          params.user = {};
          params.user.name = loginResponse.manager.name || '';
          if (!this.feedData.notes) {
            this.feedData.notes = [];
          }
          this.feedData.notes.push(params);
          // LtmsEventListener.fire("refresh-issue-history");
          // LtmsEventListener.fire("reload-feed-right-panel-filter");
          // LtmsEventListener.fire("refresh-feed-detail")
          Helpers.smallAlertBox("Success", "Notes added successfully.", "Success");
          if (cb) {
            cb(true);
          } else {
            // showing alert box for follower added when note is added (EasyFollow)
            if (_.get(response, "easyfollower_Notes") == true) {
              setTimeout(function () {
                Helpers.smallAlertBox("Success", "Follower" + " updated successfully.", "Success");
              }, 1000)


            }
            // this.rightPaneloaded = false;
          }
        } else {
          if (cb) {
            cb(true)
          }
          Helpers.smallAlertBox("Success", "Notes added successfully.", "Success");
          this._ltmsEvent.emit('refresh-feed-detail');
        }
      } else if (_.get(response, "code") == 403) {
        Helpers.smallAlertBox("Error", "Either you are not logged in or you dont have access to update the notes.", "error");
        if (cb) {
          cb(false);
        }
      } else {
        var errorMsg = response.error_message;
        Helpers.smallAlertBox("Error", errorMsg || "Something went wrong.", "error");
        if (cb) {
          cb(false);
        }
      }

    });
  }
  selectedTag: any = {}
  isTaglistEnabled: boolean = false;
  selectTag(event: any, tag: any) {
    event.preventDefault()
    this.selectedTag = tag
    this.issueTagText = tag.name
    this.tagList = [];
    this.isTaglistEnabled = false;
  }


  assignUnassignTags(event: any, tagData: any, opCode: number) {
    event.preventDefault()
    this.tagList = []
    this.isTagButtonEnabled = false;
    const tagInput: any = document.getElementById("ltms-feed-tag-text")
    var displayText = "Tag";
    var tagText = (tagData.text) ? tagData.text : (this.selectedTag.name) ? this.selectedTag.name : null;
    var tagId = (tagData.id) ? tagData.id : (this.selectedTag.uuid) ? this.selectedTag.uuid : null;
    this.selectedTag = {}
    if (opCode == 2) {
      var index = _.indexOf(this.feedData.feed.tag_id_list, tagId);
      this.feedData.feed.tag_id_list.splice(index, 1);
      this.feedDetails.tag_id_list.splice(index, 1);
      tagId = this.feedData.feed.tag_id_list;
      tagText = null
    } else {
      this.issueTagText = ''
      this.isTaglistEnabled = false;
    }

    if (tagText || tagId) {
      this._feedService.assignTagsToFeed(_.get(this, "feedData.feed._id"), 3, tagId, tagText).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        var responseCode = _.get(response, "data.code");
        var errorMessage = _.get(response, "data.error_message");
        if (responseCode == 0) {
          if (tagText) {
            var newTag = {};
            if (!this.feedData.feed.tag_id_list || !this.feedData.feed.tag_id_list.length) {
              this.feedData.feed.tag_id_list = [];
              this.feedDetails.tag_id_list = [];
            }
            newTag['uuid'] = response["data"]["tag_id"];
            newTag['created_date'] = new Date();
            newTag['name'] = tagText;
            // Update Tag hash with the newly added tag
            this.tagHashForBrandTempTag[response["data"]["tag_id"]] = tagText;
            this.tags.push(newTag)
            //push new tag in brand tag list and issue tag list only if its unique
            if (!(_.indexOf(this.feedData.feed.tag_id_list, response["data"]["tag_id"]) > -1)) {
              this.feedData.feed.tag_id_list.push(response["data"]["tag_id"]);
              this.feedDetails.tag_id_list.push(response["data"]["tag_id"]);
              Helpers.smallAlertBox("Success", displayText + " updated successfully.", "Success");
            } else {
              //else alert tag already exists
              Helpers.smallAlertBox("Error", displayText + " already exists.", "error");

            }
            if (!(_.find(this.tags, { uuid: response["data"]["tag_id"] }))) {
              this.tags.push(newTag);
              // Updating Brand's tag_list: As, after updating the list initialize component again gets called through "reload-feed-right-panel-filter" event
              this.brandDetails.tag_list = this.tags;
            }

          } else if (tagId && opCode == 2) {

            Helpers.smallAlertBox("Success", displayText + " removed successfully.", "Success");
          }
          // this.showTags = false;//todo:show if list of tag available in list for selection;
        } else if (_.get(response, "data.code") == 4022) {
          //else alert tag already exists
          Helpers.smallAlertBox("Error", displayText + " already exists.", "error");
        } else {
          if (opCode == 2) {
            // In case of failure and opcode as 2, add back the id to the issue's tag list. As we've removed previously
            this.feedData.feed.tag_id_list.push(tagId);
            this.feedDetails.tag_id_list.push(tagId);
          }
          if (responseCode == 4022) {
            Helpers.smallAlertBox("Error", displayText + " already exists.", "error");
          } else {
            Helpers.smallAlertBox("Error", errorMessage || "Something went wrong.", "error");
          }

        }
        if (responseCode == 0) {
          // LtmsEventListener.fire("reload-feed-right-panel-filter");
          this._ltmsEvent.emit("refresh-feed-detail");
          // // this.rightPaneloaded = false;
          // LtmsEventListener.fire("refresh-issue-history");
        }
        // Unset tag input element.
        // 6082190410LP-fix for previously added tags were being added as model was not resetting
        this.issueTagText = ""
        if (tagInput) {
          tagInput.value = '';
        }
      });
    } else {
      if (opCode == 1) {
        Helpers.smallAlertBox("Warning", "Please provide " + displayText.toLowerCase() + " value", "warn");
      }
    }

  }

  selectCategory(event: any, category: any) {
    event.preventDefault();
    event.stopPropagation();
    this.isSubCatoryEnabled = false;
    this.selectedCategoryUUIDList = [];
    this.selectedCategoryUUIDList.push(category.uuid)
    this.selectedCategories = {
      selectedCategoryId: category.uuid,
      category: (this.categoryListMap[category.uuid]) ? this.categoryListMap[category.uuid] : {},
      sub_category: {}
    }
  }

  updateCategory(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (!_.isEmpty(this.selectedCategories) && _.hasIn(this.selectedCategories, 'category.children') && this.selectedCategories.category.children.length) {
      this.subCategoryDropDown = {
        options: _.map(this.selectedCategories.category.children, (value: any) => {
          value.value = value.uuid
          return value;
        })
      }
      this.isSubCatoryEnabled = true;
    } else if (!_.isEmpty(this.selectedCategories) && _.hasIn(this.selectedCategories, 'category') && !_.isEmpty(this.selectedCategories, 'category')) {
      this.assignCategory()
    } else {
      Helpers.smallAlertBox("Error", "Please select the category.", "error");
    }
    this.dropdowns.category = false;
  }

  selectSubCategory(event: any, subCategory: any) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedCategoryUUIDList.push(subCategory.uuid)
    this.selectedCategories.selectedSubCategoryId = subCategory.uuid;
    this.selectedCategories.sub_category = (this.categoryListMap[subCategory.uuid]) ? this.categoryListMap[subCategory.uuid] : {}
  }
  updateSubcategory(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.dropdowns.sub_category = false;
    if (this.selectedCategories.sub_category && _.hasIn(this.selectedCategories, "sub_category") && !_.isEmpty(this.selectedCategories.sub_category)) {
      this.assignCategory();
    } else {
      Helpers.smallAlertBox("Error", "Please select the sub category.", "error");
    }

  }

  assignCategory() {
    this.actionSelected = "CATEGORY_CHANGED";
    var isValid = false;
    var displayText = 'Category'// (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig['category']) ? this.accordionVisibilityFinalConfig['category']["display_name"] : "Category";
    var errorMsg = "Please select " + displayText.toLowerCase() + ".";
    var isSubCategory = false;
    var categoryIdList: any = [];
    var selectedCategoryId: any = this.selectedCategoryUUIDList[0];
    var selectedSubCategoryId = this.selectedCategoryUUIDList[1];
    if (_.get(this.feedData, "category_details.0.uuid") == selectedCategoryId && _.get(this.feedData, "category_details.1.uuid") == selectedSubCategoryId) {
      errorMsg = displayText + " already assigned."
    } else if (selectedCategoryId || selectedSubCategoryId) {
      // Check within category hash for the selected category
      if (selectedCategoryId && this.categoryListMap[selectedCategoryId]) {
        categoryIdList.push(selectedCategoryId);
        // check for children within category
        if (_.get(this.categoryListMap, selectedCategoryId + ".children.0")) {
          // var selectedSubCategoryId = $('#issueSubCategory option:selected')[0].value;
          // Check within category hash for the selected sub category
          if (selectedSubCategoryId && this.categoryListMap[selectedSubCategoryId]) {
            isValid = true;
            isSubCategory = true;
            categoryIdList.push(selectedSubCategoryId);
          } else {
            errorMsg = "Please select Sub " + displayText.toLowerCase() + "."
          }
        } else {
          isValid = true;
        }
      }
    }
    if (isValid) {
      var feedDetail = _.get(this.feedData, "feed") ? Helpers.deepClone(_.get(this.feedData, "feed")) : {};
      var oldCategoryValue = feedDetail.category_id_list;

      feedDetail.category_id_list = categoryIdList;
      feedDetail.tags = this.feedData.tags
      const brandDetail = Helpers.brandDetails || this.brandDetails
      feedDetail.brandDetail = Helpers.deepClone(brandDetail);
      if (this.is_action_workflow_enabled) {

        this._feedService.getUiRuleStatus({
          brand_id: this.brandDetails._id,
          event_name: "LW_RESPONSE_CATEGORY_CHANGED",
          feed_detail: Helpers.deepClone(feedDetail)
        }).pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe((response) => {
          if (response && response.code == 0 && response.data.data.actions) {
            this.LwActionsExecutor.execute(response.data.data.actions, Helpers.deepClone(feedDetail), this.serviceToPass, (err, success) => {
              if (!err) {
                this._feedService.assignTagsToFeed(_.get(this, "feedData.feed._id"), 2, categoryIdList, null).pipe(
                  takeUntilDestroyed(this.destroyRef)
                ).subscribe((response) => {
                  this.updateCategoryDetails(response, displayText, selectedCategoryId, selectedSubCategoryId, isSubCategory)
                });
              } else {
                feedDetail.category_id_list = oldCategoryValue;
              }
            })
          } else {
            console.warn("NO ui Rule found");
          }
        });


      } else {
        this._feedService.assignTagsToFeed(_.get(this, "feedData.feed._id"), 2, categoryIdList, null,).pipe(
          takeUntilDestroyed(this.destroyRef)
        ).subscribe((response) => {
          this.updateCategoryDetails(response, displayText, selectedCategoryId, selectedSubCategoryId, isSubCategory)
        });
      }
    } else {
      console.error("Error", errorMsg, "error");
    }
  }

  updateCategoryDetails(response: any, displayText: string, selectedCategoryId: string, selectedSubCategoryId: string, isSubCategory: boolean) {
    var responseCode = _.get(response, "data.code");
    var errorMessage = _.get(response, "data.error_message");
    if (responseCode == 0) {
      // Update category_details
      this.feedData.category_details = [];
      this.feedData.feed.category_id_list = [];
      this.feedData.category_details.push(this.categoryListMap[selectedCategoryId]);
      this.feedData.feed.category_id_list.push(selectedCategoryId);
      if (isSubCategory) {
        this.feedData.category_details.push(this.categoryListMap[selectedSubCategoryId]);
        this.feedData.feed.category_id_list.push(selectedSubCategoryId);
      }

      // LtmsEventListener.fire("refresh-issue-history");
      // LtmsEventListener.fire("reload-feed-right-panel-filter");
      this._ltmsEvent.emit("refresh-feed-detail");
      Helpers.smallAlertBox("Success", displayText + " updated successfully.", "Success");
    } else if (responseCode == 4022) {
      Helpers.smallAlertBox("Error", displayText + " is already assigned.", "error");
    } else {
      Helpers.smallAlertBox("Error", errorMessage || "Something went wrong.", "error");
    }
  }

  onRCAChange(event: any, rcaText: string) {
    event.preventDefault();
    if (event.target) {
      event.target.setAttribute("style", "outline: none;");
    }
    if (rcaText && rcaText.trim() != '') {
      this.isRCAButtonEnabled = true
    } else {
      this.issueRCAText = ''
      this.isRCAButtonEnabled = false
    }
  }

  submitRCA(event: any, rcaText: string) {
    event.preventDefault();
    if (rcaText.trim() != '') {
      this.createNote(event, rcaText, true, (noteAdded: any) => {
        if (noteAdded) {
          if (this.selectedStatus && this.selectedStatus.uuid && this.actionSelected == "STATUS_CHANGED") {
            this.setStatus(this.selectedStatus, 1)
          }
          if (this.selectedCategoryUUIDList && this.selectedCategoryUUIDList.length && this.actionSelected == "CATEGORY_CHANGED") {
            var categoryIdList = (this.selectedCategoryUUIDList && this.selectedCategoryUUIDList.length) ? this.selectedCategoryUUIDList : [];
            this.setStatus(categoryIdList, 2);
          }
          if (this.selectedTag && this.selectedTag.uuid && this.actionSelected == "TAG_CHANGED") {
            let selectedstatusId = (this.selectedStatus && this.selectedStatus.uuid) ? this.selectedStatus.uuid : this.feedDetails.tag_id_list[0];
            this.setStatus({ "uuid": selectedstatusId }, 3);
          }
          if (this.selectedAssignee && !_.isEmpty(this.selectedAssignee) && this.actionSelected == "ASSIGNEE_CHANGED") {
            this.assignUnassignIssueToManager(false, 4, false);
          }
          if (this.selectedAssignee && !_.isEmpty(this.selectedAssignee) && this.actionSelected == "FOLLOWER_CHANGED") {
            this.assignUnassignIssueToManager(false, 8, false);
          }
        }
      })
      this.closeRcaModal();
    } else {
      const rcaEl = document.getElementById('issueRCAText');
      if (rcaEl) {
        rcaEl.setAttribute("style", "outline: 2px solid #ED635E;");
      }
    }

  }
  cancelRCA() {
    var displayText = (this.accordionVisibilityFinalConfig && this.accordionVisibilityFinalConfig['notes']) ? this.accordionVisibilityFinalConfig['notes']["display_name"] : "Notes";
    Helpers.showConfirmationBox("Close " + displayText, "Are you sure you want to close the form? Changes made will not be saved.", (answer) => {
      if (answer) {
        this.closeRcaModal();
        var currentStatus = _.get(this, "feedData.status_details.0")
        this.selectedStatus = this.statusHash[this.oldStatus[0]]
        this.feedData.feed.status_id_list = this.oldStatus;
      }
    });
  }
  closeRcaModal() {
    const rcaModal = document.getElementById('issueClosureRCAModal');
    if (rcaModal) {
      rcaModal.classList.remove('show')
    }
  }

  changeNoteView(event: any, note: any) {
    event.preventDefault();
    if (note.showMore) {
      note.showMore = false;
    } else {
      note.showMore = true
    }
  }
  isEllipsisActive(note: any) {
    const id = 'note-' + note._id;
    const el = document.getElementById(id);
    if (note.showMore) {
      return true
    } else if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }

  }

  closeMangerModal() {
    this.feedDetails.roles_followed_by = _.map(this.feedDetails.roles_followed_by, (role: any) => {
      delete role.showMangerList;
      return role;
    })
    this.roleBasedAssigneeList = _.map(this.roleBasedAssigneeList, (role: any) => {
      delete role.showMangerList;
      return role;
    })

  }


  scrollConfig: any = {
    limit: 10,
    pageNumber: 1,
    isLoadMore: true,
    showScroll: true,
    targetId: ''
  }

  loadManagerDetails(assigneeDetail: any, isAssigne: boolean, isNextPage?: boolean) {
    var level = assigneeDetail['level'];
    if (isNextPage !== true) {
      this.scrollConfig.pageNumber = 1;
      this.scrollConfig.isLoadMore = true;
      this.scrollConfig.assigneeDetail = assigneeDetail;
      this.scrollConfig.isAssigne = isAssigne;
      const listPrefix = (isAssigne) ? 'assingee_list' : 'follower_list'
      this.scrollConfig.targetId = `${listPrefix}_${assigneeDetail.level}_${assigneeDetail.value}`
      this.closeMangerModal();
    }
    if (this.scrollConfig.isLoadMore) {
      var query = {
        "brand_id": this.brandDetails._id,
        "level": level,
        "level_value": assigneeDetail['value'],
        "limit": this.scrollConfig.limit,
        "page_number": this.scrollConfig.pageNumber,
        "type": 2
      }


      this.roleBasedMangerDetails.levelName = assigneeDetail['text'] || assigneeDetail['levelText'];
      this.roleBasedMangerDetails.levelValue = assigneeDetail['value'];


      this._feedService.getRoleBasedManagers(query).subscribe((response: any) => {
        if (response.code == 0 && _.hasIn(response, 'data.data') && !_.isEmpty(response.data.data)) {
          this.scrollConfig.isLoadMore = (response?.data?.data && response.data.data.length < this.scrollConfig.limit) ? false : true;

          if (isNextPage !== true) {
            this.scrollConfig.showScroll = (response?.data?.data && response.data.data.length < this.scrollConfig.limit) ? false : true;
            this.roleBasedMangerDetails.list = response.data.data;
            if (isAssigne) {
              this.roleBasedAssigneeList = _.map(this.roleBasedAssigneeList, (role: any) => {
                if (role.level == assigneeDetail['level'] && role.value == assigneeDetail['value']) {
                  role.showMangerList = true;
                } else {
                  delete role.showMangerList;
                }
                return role;
              })

            } else {

              this.feedDetails.roles_followed_by = _.map(this.feedDetails.roles_followed_by, (role: any) => {
                if (role.level == assigneeDetail['level'] && role.value == assigneeDetail['value']) {
                  role.showMangerList = true;
                } else {
                  delete role.showMangerList;
                }
                return role;
              })
            }
          } else {
            this.roleBasedMangerDetails.list = this.roleBasedMangerDetails.list.concat(response.data.data);
          }

        } else {
          console.warn("Error while fatching managers list")
        }
      }, (error) => {
        console.warn("Error while trying to fetch managers list")
      })
    }

  }

  onScrollLoadData(event: any) {
    var target = event?.currentTarget;
    if (target && (target.scrollTop + target.offsetHeight) >= target.scrollHeight) {
      this.scrollConfig.pageNumber = this.scrollConfig.pageNumber + 1;
      this.loadManagerDetails(this.scrollConfig.assigneeDetail, this.scrollConfig.isAssigne, true)
    }
  }
}
